const state = {
    data: {
        token: null,
        email: null,
        roles: [],
        name: '',
        exp: null,
    }
};

const mutations = {
    setData(state, data) {
        state.data = data
    },
    setName(state, name) {
        state.data.name = name
    },

    logout(state) {
        state.data = {}
    }
}


const getters = {

    roles: state => {
        return state.data.roles
    },
    token: state => {
        return state.data.token
    },

    email: state => {
        return state.data.email
    },

    name: state => {
        return state.data.name
    },

    exp: state => {
        return state.data.exp
    },
    isLoki: state =>{
        let isLoki = state.data.roles.some(sm => sm.authority.includes('LOKI'))
     return isLoki
    },
    isOdin: state =>{
        let isOdin = state.data.roles.some(sm => sm.authority.includes('ODIN'))
     return isOdin
    },
    isAdmin: state => {
        const rolesMss = [
            'ROLE_ADMIN_ODIN',
            'ROLE_REPORT_MANAGER_ODIN',
            'ROLE_AGREEMENT_MANAGER_ODIN',
            'ROLE_GROUP_MANAGER_ODIN',
            'ROLE_SECURITY_ANALYST_ODIN',
            'ROLE_ADMIN_LOKI',
            'ROLE_REPORT_MANAGER_LOKI',
            'ROLE_AGREEMENT_MANAGER_LOKI',
            'ROLE_GROUP_MANAGER_LOKI',
            // 'ROLE_USER_LOKI',
            'ROLE_SECURITY_ANALYST_LOKI'
        ]
        let isAdmin = state.data.roles?.some(sm => {
            return rolesMss.includes(sm.authority)
        }) || false
        return isAdmin
    },
   


};


export default {
    state,
    mutations,
    getters,
}